/**
 * Situacao do Post
 */
export enum PostStatus {
  /**
   * Publicada
   */
  PUBLISHED = 'PUBLISHED',
  /**
   * Não publicada
   */
  NOT_PUBLISHED = 'NOT_PUBLISHED',
  /**
   * Rascunho
   */
  DRAFT = 'DRAFT',
  /**
   * Deletado
   */
  DELETED = 'DELETED',
}

export class Posts {
  uuid: string;
  content: string;
  identifier: string;
  status: PostStatus;
  disable_comments: boolean;
  enable_home: boolean;
  total_likes: number;
  total_comments: number;
  posts_media: PostMedia[];
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
  created_at: string;
  updated_at: string;
}

export class PostMedia {
  uuid: string;
  image_url: string;
}
